import { VuexModule, Module, Action, Mutation, getModule } from 'vuex-module-decorators'
import store from '@/store'

export interface IScanforDepart {
  errorMessage:string //错误信息
}

@Module({ dynamic: true, store, name: 'store_scanfordepart' })
class ScanforDepart extends VuexModule implements IScanforDepart {
  public errorMessage = "";

  @Mutation
  public setErrorMessage(str) {
    this.errorMessage = str;
  }
}

export const ScanforDepartModule = getModule(ScanforDepart)
